import { Platform } from 'shared/src/domain/line-item/line-item-channels';

export const BEESWAX_MEDIA_PLATFORM_ID = 1;
export const TTD_MEDIA_PLATFORM_ID = 2;
export const FACEBOOK_MEDIA_PLATFORM_ID = 3;
export const GOOGLE_DV360_MEDIA_PLATFORM_ID = 4;
export const TIKTOK_MEDIA_PLATFORM_ID = 5;
export const AMAZON_DSP_MEDIA_PLATFORM_ID = 6;
export const VIANT_MEDIA_PLATFORM_ID = 7;
export const GOOGLE_SEARCH_MEDIA_PLATFORM_ID = 8;
export const YOUTUBE_MEDIA_PLATFORM_ID = 9;
export const SIMPLIFI_MEDIA_PLATFORM_ID = 10;
export const BING_MEDIA_PLATFORM_ID = 11;
export const SNAPCHAT_MEDIA_PLATFORM_ID = 12;
export const VISTAR_MEDIA_PLATFORM_ID = 13;
export const LINKEDIN_MEDIA_PLATFORM_ID = 14;
export const PINTEREST_MEDIA_PLATFORM_ID = 15;
export const GOOGLE_ADS_OTHER_MEDIA_PLATFORM_ID = 16;
export const REDDIT_MEDIA_PLATFORM_ID = 17;
export const SITE_IMPACT_MEDIA_PLATFORM_ID = 18;
export const NATIVO_MEDIA_PLATFORM_ID = 19;
export const MATCHCRAFT_MEDIA_PLATFORM_ID = 118;
export const X_TWITTER_MEDIA_PLATFORM_ID = 119;
export const AUDIOGO_MEDIA_PLATFORM_ID = 120;
export const SPOTIFY_MEDIA_PLATFORM_ID = 20;
export const CASTIRON_FIREBRAND_MEDIA_PLATFORM_ID = 124;
export const DISNEY_HULU_MEDIA_PLATFORM_ID = 125;
export const SPACEBACK_MEDIA_PLATFORM_ID = 126;

export function getPlatformName(platforms: Platform[], id: string | number | undefined) {
  const numId = Number(id);
  const platform = platforms.find(p => p.id === numId);
  return platform?.name || 'Unknown';
}

export function getPlatformEntityType(id: string | number | undefined) {
  if (!id) return '';
  switch (Number(id)) {
    case BEESWAX_MEDIA_PLATFORM_ID:
      return 'Line Item';
    case TTD_MEDIA_PLATFORM_ID:
      return 'Ad Group';
    case FACEBOOK_MEDIA_PLATFORM_ID:
      return 'Campaign';
    case GOOGLE_DV360_MEDIA_PLATFORM_ID:
      return 'Insertion Order';
    case TIKTOK_MEDIA_PLATFORM_ID:
      return 'Campaign';
    case AMAZON_DSP_MEDIA_PLATFORM_ID:
      return 'Order';
    case VIANT_MEDIA_PLATFORM_ID:
      return 'Campaign';
    case GOOGLE_SEARCH_MEDIA_PLATFORM_ID:
      return 'Campaign Budget';
    case YOUTUBE_MEDIA_PLATFORM_ID:
      return 'Campaign Budget';
    case SIMPLIFI_MEDIA_PLATFORM_ID:
      return 'Campaign';
    case BING_MEDIA_PLATFORM_ID:
      return 'Budget';
    case SNAPCHAT_MEDIA_PLATFORM_ID:
      return 'Ad Set';
    case VISTAR_MEDIA_PLATFORM_ID:
      return 'Campaign';
    case LINKEDIN_MEDIA_PLATFORM_ID:
      return 'Campaign';
    case PINTEREST_MEDIA_PLATFORM_ID:
      return 'Campaign';
    case GOOGLE_ADS_OTHER_MEDIA_PLATFORM_ID:
      return 'Campaign Budget';
    case REDDIT_MEDIA_PLATFORM_ID:
      return 'Campaign';
    case MATCHCRAFT_MEDIA_PLATFORM_ID:
      return '';
    case X_TWITTER_MEDIA_PLATFORM_ID:
      return '';
    case AUDIOGO_MEDIA_PLATFORM_ID:
      return '';
    case SPOTIFY_MEDIA_PLATFORM_ID:
      return '';
    case NATIVO_MEDIA_PLATFORM_ID:
      return 'Campaign';
    case SITE_IMPACT_MEDIA_PLATFORM_ID:
      return '';
    case CASTIRON_FIREBRAND_MEDIA_PLATFORM_ID:
      return '';
    case DISNEY_HULU_MEDIA_PLATFORM_ID:
      return '';
    case SPACEBACK_MEDIA_PLATFORM_ID:
      return '';
    default:
      return '';
  }
}
